import { UIParcoursComponentProps } from "@src/parcours/Parcours.types";
import { AssujettiParcoursConformiteEnum } from "./AssujettiParcoursConformite";

export function UIAssujettiParcoursConformite({
  children,
}: UIParcoursComponentProps<AssujettiParcoursConformiteEnum>) {
  return <div>{children}</div>;
}
